<div cropText>
  <ng-container *ngFor="let error of formControl.errors | keyvalue; let last = last">
    <ng-container *ngIf="formControl.hasError(error.key)" [ngSwitch]="true">
      <ng-container *ngSwitchCase="error.key === errorType.PatternKey">
        <span>{{ 'common.validation.error.pattern.' + getPatternKeyFromAngularError() | translate }}</span>
      </ng-container>

      <ng-container *ngSwitchCase="error.key === errorType.Pattern">
        <span>{{ 'common.validation.error.pattern.' + getPatternKeyFromAngularError() | translate }}</span>
      </ng-container>

      <ng-container *ngSwitchCase="error.key === errorType.BoschEmail">
        <span>{{ 'common.validation.error.' + error.key | translate }}</span>
      </ng-container>

      <ng-container *ngSwitchCase="error.key === errorType.DuplicateAddress">
        <span>{{ 'common.validation.error.' + error.key | translate }}</span>
      </ng-container>

      <ng-container *ngSwitchCase="error.key === errorType.Min">
        {{ 'common.validation.error.' + error.key | translate : { val: error.value.min } }}
      </ng-container>

      <ng-container *ngSwitchCase="error.key === errorType.Max">
        {{ 'common.validation.error.' + error.key | translate : { val: error.value.max } }}
      </ng-container>

      <ng-container *ngSwitchDefault
        ><span> {{ 'common.validation.error.' + error.key | translate : { val: error.value.requiredLength } }}</span>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="!last">.&nbsp;</ng-container>
  </ng-container>
</div>
